import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

class GlobalSettingsService {
  public async fetchServiceLevels() {
    return await serverApi.get(Paths.providerServiceLevel.base).then(({ data }) => data)
  }

  public async createServiceLevel(serviceLevel: { name: string }) {
    return await serverApi.post(Paths.providerServiceLevel.base, serviceLevel).then(({ data }) => data)
  }
}

const globalSettingsService = new GlobalSettingsService()
export { globalSettingsService }



// WEBPACK FOOTER //
// ./src/services/GlobalSettings.ts